import {Playshot} from "../../../../model/Playshot";
import {PlayInformationRuntimeInfo} from "./information-definitions";

export const getViewRuntimeInformation = (viewName: string, playshot: Playshot): PlayInformationRuntimeInfo | undefined => {
  const view = playshot.playConfig.views[viewName];

  if(!view) {
    return;
  }

  return playshot.playConfig.types[view.information];
}
